import React from "react";
import { CambridgeSummerConfig } from "../../../data/cambridgeSummerConfig";

interface CTAProps {
    config: CambridgeSummerConfig;
}

const CTA: React.FC<CTAProps> = () => {
    return <></>;
};

export default CTA;
